import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card-body p-4" }
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "scenario-field-header with-elements bg-secondary text-white" }, " Scorecard Display Settings ", -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("label", { class: "pb-2" }, "Scorecard Display Setting", -1)),
      _withDirectives(_createElementVNode("select", {
        class: "w-100",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.display_setting) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.display_options, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: option.id,
            value: option.id
          }, _toDisplayString(option.title), 9, _hoisted_2))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.display_setting]
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary btn-md my-3 float-end",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveDisplaySettings && _ctx.saveDisplaySettings(...args)))
      }, "Save")
    ])
  ], 64))
}